// extracted by mini-css-extract-plugin
export var animationContainer = "_i9-0";
export var asteriskIcon = "_i9-8";
export var conversationLeftSection = "_i9-4";
export var conversationListItem = "_i9-3";
export var conversationMiddleSection = "_i9-5";
export var conversationRightSection = "_i9-6";
export var detailsContent = "_i9-1";
export var listContainer = "_i9-7";
export var modalContent = "_i9-2";